module.exports = __webpack_public_path__ + "media/images/home/nl/preview-1-47984ef6a190b9a7fbb8e0d0784d52e4.jpg";